import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, useHistory, useParams } from "react-router-dom";
import Dashboard from "../Dynamic/Dashboard";
import RouteGuard from "./RouteGuard";
// import Footer from './Footer';
import Cookies from "universal-cookie";
import ActiveOrder from "../Dynamic/ActiveOrder";
import AddCompanyOrUser from "../Dynamic/AddCompanyOrUser";
import AddSupportRequest from "../Dynamic/AddSupportRequest";
import CompanyList from "../Dynamic/CompanyList";
import CompareInventory from "../Dynamic/CompareInventory";
import DuplicateInventories from "../Dynamic/DuplicateInventories";
import GroupMessageBox from "../Dynamic/GroupMessageBox";
import InventoryCSV from "../Dynamic/InventoryCSV";
import InventoryListing from "../Dynamic/InventoryListing";
import LoginHistory from "../Dynamic/LoginHistory";
import ManagePermissions from "../Dynamic/ManagePermissions";
import ManageRoles from "../Dynamic/ManageRoles";
import MyInventories from "../Dynamic/MyInventories";
import MyRequests from "../Dynamic/MyRequests";
import OfferRequest from "../Dynamic/OfferRequest";
import OrderDetail from "../Dynamic/OrderDetail";
import ProductDetail from "../Dynamic/ProductDetail";
import SampleRequest from "../Dynamic/SampleRequest";
import SupportRequest from "../Dynamic/SupportRequest";
import UserList from "../Dynamic/UserList";
import ViewCSV from "../Dynamic/ViewCSV";
import ViewInventoryListingDetails from "../Dynamic/ViewInventoryListingDetails";
import ViewOfferRequest from "../Dynamic/ViewOfferRequest";
import ViewSampleRequest from "../Dynamic/ViewSampleRequest";
import ViewSellRequest from "../Dynamic/ViewSellRequest";
import ViewSoldInventoryListingDetails from "../Dynamic/ViewSoldInventoryListingDetails";
import ViewSupportRequest from "../Dynamic/ViewSupportRequest";
import CompanyDashboard from "../Dynamic/CompanyDashboard";
import ViewOrEditProfile from "../Static/Profile/ViewOrEditProfile";
import Header from "./Header";
import UATbelt from "./UATbelt";
import InsurancePricingPanel from "../Dynamic/InsurancePricingPanel";
import BarrelMarketValue from "../Dynamic/BarrelMarketValue";
import BarrelMarketValueChartView from "../Dynamic/BarrelMarketValueChartView";
import MarketValueHistory from "../Dynamic/MarketValueHistory";
import TransferLotBarrels from "../Dynamic/TransferLotBarrels";
import TransferLotLogsPanel from "../Dynamic/TransferLotLogsPanel";
import BarrelSyncPanel from "../Dynamic/BarrelSyncPanel";
import AddContractServicePrice from "../Dynamic/AddContractServicePriceOrWarehouse";
import AddContractServicePriceOrWarehouse from "../Dynamic/AddContractServicePriceOrWarehouse";
import AddContract from "../Dynamic/AddContract";
import CompaniesContractListing from "../Dynamic/CompaniesContractListing";
import ViewContract from "../Dynamic/ViewContract";
import ContractPricingListing from "../Dynamic/ContractPricingListing";
import ViewContractPricingDetails from "../Dynamic/ViewContractPricingDetails";
import Typesense from "../Dynamic/Typesense";
import SellRequestHistory from "../Dynamic/SellRequestEditHistory";
import EditBarrel from "../Dynamic/EditBarrel";
import ProofHistory from "../Dynamic/ProofHistory";
import WarehouseDashboard from "../Dynamic/WarehouseDashboard";
import AllRequest from "../Dynamic/AllRequest";
import ValuationHistory from "../Dynamic/ValuationHistory";
import WantedToBuyTypesense from "../Dynamic/WantedToBuyTypesense";
import WantedToBuyProductDetail from "../Dynamic/WantedToBuyProductDetail";
import StackDetails from "../Dynamic/StackDetails";
import WarehouseLocations from "../Dynamic/WarehouseLocations";
import ContainerDetail from "../Dynamic/ContainerDetail";
import ContainerHistory from "../Dynamic/ContainerHistory";
import TastingHistory from "../Dynamic/TastingHistory";
import ViewTastingHistory from "../Dynamic/ViewTastingHistory";
import AddTastingDetail from "../Dynamic/AddTastingDetail";
import EditLotDetails from "../Dynamic/EditLotDetails";
import ReportingListing from "../Dynamic/ReportingListing";
import OwnershipTransferListing from "../Dynamic/OwnershipTransferListing";
import LogisticRequestListing from "../Dynamic/LogisticRequestListing";
import CompanyInventorySummaryReport from "../Dynamic/CompanyInventorySummaryReport";
import CompanyBillingActivityReport from "../Dynamic/CompanyBillingActivityReport";
import TTBReport from "../Dynamic/TTBReport";

const Layout = () => {
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserRole = () => {
      const cookies = new Cookies();
      const role = cookies.get("userRole");
      setUserRole(role);
    };

    fetchUserRole();
  }, []); // Empty dependency array ensures this effect runs only once

  if (userRole === null) {
    // Render loading indicator while fetching user role
    return <div>Loading...</div>;
  }

  function NotFoundRedirect() {
    const history = useHistory();
    const userRole = localStorage.getItem("userRole");

    useEffect(() => {
      if (userRole === "SUPER_ADMIN") {
        history.replace("/master/dashboard");
      } else {
        history.replace("/user/inventories");
      }
    }, [userRole, history]);
  
    useEffect(() => {
      if (userRole === "SUPER_ADMIN") {
        history.replace("/master/dashboard");
      } else {
        history.replace("/user/wanted-to-buy");
      }
    }, [userRole, history]);

    return null; // No UI needed
  }

  return (
    <div>
      <UATbelt />
      <Header />
      <Switch>
        <Route exact path="/master/my-profile/:id">
          <ViewOrEditProfile />
        </Route>

        <Route exact path="/master/manage-requests">
          <MyRequests />
        </Route>

        <RouteGuard exact path="/master/dashboard">
          {/* {userRole === 'SUPER_ADMIN' ? <Dashboard /> : <Redirect to="/inventory" />} */}
          <Dashboard />
        </RouteGuard>

        <Route exact path="/master/user-list">
          <UserList />
        </Route>

        <Route exact path="/master/inventory">
          <MyInventories />
        </Route>

        <Route exact path="/master/warehouse-locations">
          <WarehouseLocations />
        </Route>

        <Route exact path="/master/available-barrel">
          <MyInventories />
        </Route>

        <Route exact path="/master/reserved-barrel">
          <MyInventories />
        </Route>

        <Route exact path="/master/marketplace-listings">
          <InventoryListing />
        </Route>

        <Route exact path="/master/ownership-transfer-listings">
          <OwnershipTransferListing />
        </Route>

        <Route exact path="/master/my-warehouse/marketplace-listings/:id">
          <InventoryListing />
        </Route>

        <Route exact path="/master/view-inventory-listing-details/:id">
          <ViewInventoryListingDetails />
        </Route>

        <Route exact path="/master/view-sold-inventory-listing-details/:id">
          <ViewSoldInventoryListingDetails />
        </Route>

        <Route exact path="/master/inventory-sell-requests">
          <InventoryCSV />
        </Route>

        <Route exact path="/master/inventory-sell-requests/:id">
          <InventoryCSV />
        </Route>

        <Route exact path="/master/product-details/:id">
          <ProductDetail />
        </Route>

        <Route exact path="/master/view-csv/:id">
          <ViewCSV />
        </Route>

        <RouteGuard exact path="/master/edit-barrel/:id">
          <EditBarrel />
        </RouteGuard>

        <RouteGuard exact path="/master/proof-history/:id">
          <ProofHistory />
        </RouteGuard>

        <RouteGuard exact path="/master/valuation-history/:id">
          <ValuationHistory />
        </RouteGuard>

        <Route exact path="/master/view-sell-request/:id">
          <ViewSellRequest />
        </Route>

        <Route exact path="/master/order-detail/:id">
          <OrderDetail />
        </Route>

        <Route exact path="/master/login-history">
          {}
          <LoginHistory />
        </Route>

        <Route exact path="/master/active-order">
          <ActiveOrder />
        </Route>

        <Route exact path="/master/my-warehouse/active-order/:id">
          <ActiveOrder />
        </Route>

        <Route exact path="/master/sample-request">
          <SampleRequest />
        </Route>

        <Route exact path="/master/view-sample-request/:id">
          <ViewSampleRequest />
        </Route>

        <Route exact path="/master/my-warehouse/sample-request/:id">
          <SampleRequest />
        </Route>

        <Route exact path="/master/inventory-listing/:id">
          <SampleRequest />
        </Route>

        <Route exact path="/master/offer-request">
          <OfferRequest />
        </Route>

        <Route exact path="/master/view-offer-request/:id">
          <ViewOfferRequest />
        </Route>

        <Route exact path="/master/my-warehouse/offer-request/:id">
          <OfferRequest />
        </Route>

        <Route exact path="/master/messages">
          <GroupMessageBox />
        </Route>

        <Route exact path="/master/company-list">
          <CompanyList />
        </Route>

        <Route exact path="/master/company-dashboard/:id">
          <CompanyDashboard />
        </Route>

        <Route exact path="/master/add-user">
          <AddCompanyOrUser type={"user"} />
        </Route>

        <Route exact path="/master/add-company">
          <AddCompanyOrUser type={"company"} />
        </Route>

        <Route exact path="/master/edit-company/:id">
          <AddCompanyOrUser type={"company"} />
        </Route>

        <Route exact path="/master/my-warehouse/user-list/:id">
          <UserList />
        </Route>

        <Route exact path="/master/inventory-change-requests">
          <MyInventories />
        </Route>

        <Route exact path="/master/compare-inventory/:id">
          <CompareInventory />
        </Route>

         <Route exact path="/master/view-edit-sell-request-history/:requestId/:historyId">
          <SellRequestHistory />
        </Route>

        <Route exact path="/master/user-detail/:id">
          <ViewOrEditProfile />
        </Route>

        <Route exact path="/master/my-warehouse/inventory/:id">
          <MyInventories />
        </Route>

        <Route exact path="/master/my-warehouse/available-for-sell/:id">
          <MyInventories />
        </Route>

        <Route exact path="/master/my-warehouse/not-available-for-sell/:id">
          <MyInventories />
        </Route>

	      <Route exact path="/master/duplicate-inventory">
          <DuplicateInventories/>
        </Route>

        <Route exact path= "/master/manage-permissions/:id">
        <ManagePermissions/>
        </Route>

        <Route exact path = "/master/manage-roles">
        <ManageRoles/>
        </Route>

        <Route exact path="/master/company-dashboard-as-buyer/:id">
          <CompanyDashboard />
        </Route>

        <Route exact path="/master/company-dashboard-as-owner/:id">
          <CompanyDashboard />
        </Route>
        
        <Route exact path="/master/customer-service">
          <SupportRequest />
        </Route>

        <Route exact path="/master/customer-service/:id">
          <SupportRequest />
        </Route>

        <Route exact path="/master/add-customer-service-request">
          <AddSupportRequest />
        </Route>
        
        <Route exact path="/master/view-customer-service-request/:id">
          <ViewSupportRequest />
        </Route>

        <Route exact path="/master/edit-customer-service-request/:id">
          <AddSupportRequest />
        </Route>

        <Route exact path="/master/barrel-sync-log">
          <BarrelSyncPanel />
        </Route>

        <Route exact path="/master/transfer-lot-logs/:id">
          <TransferLotLogsPanel />
        </Route>

        <Route exact path="/master/transfer-lot-barrels/:id">
          <TransferLotBarrels />
        </Route>

        <Route exact path="/master/insurance-pricing">
          <InsurancePricingPanel/>
        </Route>

        <Route exact path="/master/insurance-pricing/edit">
          <InsurancePricingPanel/>
        </Route>

        <Route exact path="/master/market-value-history/:id/:lotId">
          <MarketValueHistory/>
        </Route>

        <Route exact path="/master/barrel-market-value-chart-view/:id/:lotId">
          <BarrelMarketValueChartView/>
        </Route>

        <Route exact path="/master/barrel-market-value/:id">
          <BarrelMarketValue/>
        </Route>

        <Route exact path = "/master/add-contract">
          <AddContract/>
        </Route>

         <Route exact path = "/master/edit-contract/:id">
          <AddContract/>
        </Route>

        <Route exact path = "/master/view-contract">
          <CompaniesContractListing/>
        </Route>

        <Route exact path = "/master/view-contract/:id">
          <ViewContract/>
        </Route>

        <Route exact path = "/master/contract-pricing">
          <ContractPricingListing/>
        </Route>

        <Route exact path = "/master/contract-pricing-details/:id">
          <ViewContractPricingDetails/>
        </Route>

        <Route exact path="/master/product-details/:id">
          <ProductDetail />
        </Route>

        <Route exact path="/master/inventories">
          <Typesense />
        </Route>

        <Route exact path="/master/wanted-to-buy">
          <WantedToBuyTypesense />
        </Route>

        <Route exact path="/master/wanted-to-buy-product-details/:id">
          <WantedToBuyProductDetail />
        </Route>

        <Route exact path="/master/service-requests-and-queue">
          <Dashboard />
        </Route>

        <Route exact path="/master/logistic-requests">
          <Dashboard />
        </Route>

        <Route exact path="/master/inbound-requests">
          <LogisticRequestListing />
        </Route>

        <Route exact path="/master/outbound-requests">
          <LogisticRequestListing />
        </Route>

        <Route exact path="/master/external-requests">
          <LogisticRequestListing />
        </Route>

        <Route exact path="/master/my-warehouse/service-requests/:id">
          <CompanyDashboard />
        </Route>

        <Route exact path="/master/storage-dashboard">
          <WarehouseDashboard />
        </Route>

        <Route exact path="/master/all-request">
          <AllRequest />
        </Route>

        <RouteGuard exact path="/master/container-detail/:id">
          <ContainerDetail />
        </RouteGuard>

        <Route exact path="/master/container-history-detail/:id">
          <ContainerHistory/>
        </Route>

        <Route exact path="/master/tasting-history">
          <TastingHistory/>
        </Route>

        <Route exact path="/master/tasting-history-detail">
          <ViewTastingHistory/>
        </Route>
        
        <Route exact path="/master/add-tasting-detail/:id">
          <AddTastingDetail/>
        </Route>

        <RouteGuard exact path="/master/edit-lot-details/:id">
          <EditLotDetails />
        </RouteGuard>

        <Route exact path="/master/reporting">
          <ReportingListing />
        </Route>

        <Route exact path="/master/company-inventory-summary">
          <CompanyInventorySummaryReport />
        </Route>

        <Route exact path="/master/company-activity-summary">
          <CompanyBillingActivityReport />
        </Route>

        <Route exact path="/master/ttb-reporting">
          <TTBReport />
        </Route>

        {/* <Route exact path = "/master/contract/add-contract-service-price">
          <AddContractServicePriceOrWarehouse type ={"price"}/>
        </Route>

        <Route exact path = "/master/contract/add-warehouse">
          <AddContractServicePriceOrWarehouse type ={"warehouse"}/>
        </Route> */}

        {/* <Route path="/">
          {userRole === "SUPER_ADMIN" ? ( */}

          
        {/* <Route path="*">
          {CommonService.isAdmin() ? (
            <Redirect to="master/dashboard" />
          ) : (
            <Redirect to="user/inventories" />
          )}
        </Route> */}

        <Route path="*" component={NotFoundRedirect} />

      </Switch>
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;
